<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="Prórrogas" key="1">
        <a-row>
          <g-master name="prorrogas"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    ref="master"
                    modalWidth="80%"
                    @action="masterAction"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <g-lookup :label="$t('Empleado')"
                            :formItemConfig="fiOptions"
                            endpoint="empleados"
                            :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                  >
                  </g-lookup>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Fecha inicial')" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   v-decorator="['initial_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Fecha final')" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   v-decorator="['end_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown :label="$t('Tipo de contrato')"
                              :formItemConfig="fiOptions"
                              endpoint="hierarchy_lookup"
                              :params="tipoContrato"
                              :decorator="['tcontract', { rules: [{ required: true, message:'Valor requerido'}] }]">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown :label="$t('Motivo de la prórroga')"
                              :formItemConfig="fiOptions"
                              endpoint="hierarchy_lookup"
                              :params="motivoProrroga"
                              :decorator="['cause_prorroga', { rules: [{ required: true, message:'Valor requerido'}] }]">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Comentarios')">
                    <a-textarea auto-size
                                v-decorator="['comments', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-row>
      </a-tab-pane>
      <a-tab-pane key="2" v-if="roleLoad">
        <span slot="tab">
          <g-wiki width="50%" keyValue="WIKI_CARGUE_PROROGATION">
            <template slot="customText">
              <a-button type="primary" value="large" :loading="loadingTemplate" @click="downloadTemplate">
                <a-icon type="file-excel"/>
                Plantilla excel
              </a-button>
            </template>
          </g-wiki>
          Cargue Masivo Prorrogas
        </span>
        <cargue_prorogation @loadData="loadData"/>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        loadingTemplate: false,
        tipoContrato: {h_lookup_type: 'TIPO_CONTRATO'},
        motivoProrroga: {h_lookup_type: 'MOTIVO_PRORROGA'},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        loadingBtns: {},
        colOptions: {xs: 24, sm: 12},
        master: {
          endpoint: 'prorogation',
          tableSetup: {
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                },
                {
                  name: 'download',
                  text: 'Descargar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'file-pdf', style: 'color: red'},
                  fnVisible: (record) => {
                    return this.$getConfigValue('REPORTES_PRORROGA', 'vacio') !== 'vacio'
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id] === record.id
                  }
                }
              ]
            },
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Código del empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre', dataIndex: 'complete_name', sorter: true},
              {title: 'Tipo contrato actual', dataIndex: 'contrato_actual', sorter: true},
              {title: 'Fecha inicio prórroga', dataIndex: 'inicio_prorroga', sorter: true},
              {title: 'Fecha fin contrato', dataIndex: 'fin_contrato', sorter: true},
              {title: 'Cantidad de meses', dataIndex: 'mes', sorter: true},
              {title: 'Nuevo tipo de contrato', dataIndex: 'tcontract_desc', sorter: true},
              {title: 'Causa de la prórroga', dataIndex: 'cuasa_prorrogacion', sorter: true},
              {title: 'Fecha inicial actual', dataIndex: 'inicio_contrato', sorter: true},
              {title: 'Fecha fin actual', dataIndex: 'fin_prorroga', sorter: true},
              {title: 'Número de prórroga', dataIndex: 'numero_prorroga', sorter: true},
              {title: 'Comentarios', dataIndex: 'comments', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_emp'},
            {name: 'initial_date'},
            {name: 'end_date'},
            {name: 'tcontract'},
            {name: 'cause_prorroga'},
            {name: 'comments'}
          ]
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'download':
            this.downloadFile(action.record)
            break
        }
      },
      downloadFile (record) {
        this.loadingBtns[record.id] = record.id
        this.loadingBtns = Object.assign({}, this.loadingBtns)

        this.httpClient.getInstance().post('prorogation/download', {
          params: {
            id_emp: record.id_emp,
            p_web_user: ''
          }
        }, {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }
          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          delete this.loadingBtns[record.id]
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })
      },
      downloadTemplate () {
        this.loadingTemplate = true
        this.httpClient.getInstance().get('template_prorrogas/download', {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }
          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          this.loadingTemplate = false
        })
      },
      loadData () {
        this.$refs.masterComponent && this.$refs.masterComponent.$refs.datatable.loadData()
      }
    },
    computed: {
      roleLoad () {
        return this.$userIsInrol('LoadProrrogas')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/Prorrogas/Prorrogas.vue